import { SeoContent } from '~shared/models';
export interface CustomPlpState {
  filters: {
    categoryIds?: any[];
    isHasPromotion?: boolean;
    promoTag?: string;
  };
  itemIds?: any[];
  sortedIds?: any[];
  slug: string;
  header: string;
  title?: string;
  description?: string;
  image: {};
  is_published: boolean;
  seoContent: SeoContent;
}

export const CustomPlpInitialState: CustomPlpState = {
  filters: {
    categoryIds: [],
    isHasPromotion: false,
    promoTag: '',
  },
  itemIds: [],
  sortedIds: [],
  slug: '',
  header: '',
  title: '',
  description: '',
  image: {},
  is_published: false,
  seoContent: {
    active: false,
    introContent: '',
    advisoryContentTitle: '',
    advisoryContentDescription: '',
    otherContent: '[]',
    banners: [],
  },
};
